export const EMPTY_INPUT_VALUE = ''
export const DEFAULT_SEARCH_THRESHOLD = 10
export const DEFAULT_LIMIT = 200
